import { useCompany } from "Components/Company/hooks/useCompany";
import { useScheduleEntries } from "Components/ScheduleEntry/hooks/useScheduleEntries";
import { useEffect } from "react";
import { useProjects } from "./useProjects";

export const useSubscribeToProjects = () => {
	const scheduleEntries = useScheduleEntries((state) => state.items);
	const isInitializingScheduleEntries = useScheduleEntries(
		(state) => state.isInitializing
	);
	const companyId = useCompany((state) => state.item?.id);
	const activeProjects = useProjects((state) => state.activeProjects);
	const isInitializingProjects = useProjects((state) => state.isInitializing);
	const activeProjectIds = activeProjects.map((p) => p.id);
	const scheduleEntryProjectIds = scheduleEntries.reduce<string[]>(
		(result, entry) => {
			if (!entry.projectId) return result;
			if (activeProjectIds.includes(entry.projectId)) return result;
			result.push(entry.projectId);
			return result;
		},
		[]
	);

	const missingProjectIds = [...new Set(scheduleEntryProjectIds)];
	const joinedMissingProjectIds = missingProjectIds.join(",");

	// Subscribe to ACTIVE projects
	useEffect(() => {
		return useProjects.getState().subscribeToActiveProjects(companyId);
	}, [companyId]);

	// Fetch ARCHIVED projects
	useEffect(() => {
		if (isInitializingProjects) return;
		if (isInitializingScheduleEntries) return;
		if (!joinedMissingProjectIds) return;

		void useProjects
			.getState()
			.startFetchingArchivedProjects(joinedMissingProjectIds.split(","));
	}, [
		isInitializingProjects,
		isInitializingScheduleEntries,
		joinedMissingProjectIds, // We are using a string, to make the effect dependency unique.
	]);

	useEffect(() => {
		return useProjects.getState().reset;
	}, []);
};
